import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import Seo from "@/components/Seo";
import { Reveal, Chapter } from "@/components/Reveal";
import { CTARow } from "@/components/CTA";
import { SITE } from "@/data/site";
import { SERVICES, CATEGORY_LABELS } from "@/data/services";

const ORDER = ["passport", "visa", "business", "documents"];

export default function ServicesIndexPage() {
  return (
    <>
      <Seo
        title="Passport, Visa & Travel Document Services | Travel Passport and Visa LLC"
        siteName={SITE.siteName}
        description="Explore passport services, visa assistance, business travel documentation, apostilles, authentication, and translation services from a private Washington, DC company. Call 866-334-8472."
      />
      <section className="grain bg-navy py-16 lg:py-24" data-testid="services-index-hero">
        <div className="mx-auto max-w-7xl px-4 sm:px-6">
          <span className="inline-block rounded-full border border-gold/40 px-4 py-1.5 text-[10px] font-bold uppercase tracking-[0.25em] text-gold">
            Private Service Provider
          </span>
          <h1 className="mt-5 max-w-3xl font-display text-4xl font-bold tracking-tight text-white sm:text-5xl">
            Our Services
          </h1>
          <p className="mt-5 max-w-xl text-base leading-relaxed text-slate-300 sm:text-lg">
            Professional passport, visa, and travel document assistance for individuals, families, and businesses.
          </p>
          <CTARow light className="mt-8" testPrefix="services-index" />
        </div>
      </section>
      <section className="bg-white py-16 lg:py-24">
        <div className="mx-auto max-w-7xl space-y-16 px-4 sm:px-6">
          {ORDER.map((cat, ci) => (
            <div key={cat} id={`${cat}-services`} className="scroll-mt-28" data-testid={`services-group-${cat}`}>
              <Reveal>
                <Chapter num={`0${ci + 1}`} label={CATEGORY_LABELS[cat]} />
                <div className="grid gap-4 sm:grid-cols-2 lg:grid-cols-3">
                  {SERVICES.filter((s) => s.category === cat).map((s) => (
                    <Link
                      key={s.slug}
                      to={`/services/${s.slug}`}
                      data-testid={`services-index-${s.slug}`}
                      className="group flex flex-col rounded-2xl border border-slate-200 p-7 transition-all duration-300 hover:-translate-y-1 hover:border-gold/60 hover:shadow-xl hover:shadow-navy/5"
                    >
                      <h2 className="font-display text-lg font-bold text-navy group-hover:text-gold-dark">{s.name}</h2>
                      <p className="mt-2 flex-1 text-sm leading-relaxed text-slate-600">{s.tagline}</p>
                      <span className="mt-4 inline-flex items-center gap-1.5 font-display text-sm font-semibold text-navy">
                        Learn More <ArrowRight className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-1" />
                      </span>
                    </Link>
                  ))}
                </div>
              </Reveal>
            </div>
          ))}
        </div>
      </section>
    </>
  );
}
